import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    standalone: false,
    selector: 'particle-add-link-dialog',
  templateUrl: './add-link-dialog.component.html',
  styleUrls: ['./add-link-dialog.component.scss']
})
export class AddLinkDialogComponent implements OnInit {
  data: DialogModel;
  inputForm: FormGroup;
  inputFormError: any;
  unsubscribe$ = new Subject<void>();
  text: string;
  link: string;

  constructor(private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public info: DialogModel) {
    this.inputFormError = {
      text: {},
      link: {}
    };
  }

  ngOnInit() {
    const urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

    this.inputForm = this.formBuilder.group({
      text: [this.data.input.displayText, Validators.required],
      link: [this.data.input.url, [Validators.required, Validators.pattern(urlRegex)] ]
    });

    if (this.data.input.displayText === '' && this.data.input.url === '') {
      this.info.isDisabledOkButton = true;
    }

    this.inputForm.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
  }

  onOkClicked() {
    this.data.input.displayText = this.text;
    this.data.input.url = this.link;
    return true;
  }

  onFormValuesChanged () {
    for (const field in this.inputFormError) {
      if (!this.inputFormError.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormError[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormError[field] = control.errors;
        this.info.isDisabledOkButton = true;
      } else {
        if (field === 'text') {
          this.text = control.value.trim();
        } else if (field === 'link') {
          this.link = control.value.trim();
        }
        if (this.text && this.link) {
          this.info.isDisabledOkButton = false;
        }
      }
    }
  }

}
